import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from '../services/api';

const Register = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    university_id: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const validateForm = () => {
    if (formData.password !== formData.confirmPassword) {
      setError("Passwords don't match");
      return false;
    }
    if (!formData.university_id) {
      setError("University ID is required");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!validateForm()) {
      return;
    }
    
    setLoading(true);
    
    try {
      // Remove confirmPassword before sending to API
      const { confirmPassword, ...userData } = formData;
      
      const response = await axios.post('/api/auth/register', userData);
      
      // Show success message if available
      if (response.data.message) {
        alert(response.data.message);
      }
      
      // Redirect to login after successful registration
      navigate('/login', { state: { registrationSuccess: true } });
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      width: '100%',
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#F5F7FA',
      padding: '40px 0'
    }}>
      <div style={{
        width: '500px',
        background: 'white',
        borderRadius: '12px',
        padding: '30px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
      }}>
        <div style={{textAlign: 'center', marginBottom: '30px'}}>
          <h1 style={{
            fontSize: '28px',
            color: '#F04915',
            fontFamily: 'Outfit, sans-serif',
            fontWeight: '700'
          }}>
            Admin Registration
          </h1>
          <p style={{color: '#798AA3', fontSize: '16px', fontFamily: 'Outfit, sans-serif'}}>
            Register as an administrator for AttenZef
          </p>
        </div>

        {error && (
          <div style={{
            padding: '12px',
            background: '#FFF0F0',
            color: '#CF1717',
            borderRadius: '8px',
            marginBottom: '20px',
            fontSize: '14px',
            fontFamily: 'Outfit, sans-serif'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{marginBottom: '20px'}}>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              color: '#131A1A',
              fontSize: '16px',
              fontFamily: 'Outfit, sans-serif',
              fontWeight: '500'
            }}>
              Full Name <span style={{color: '#F04915'}}>*</span>
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                height: '48px',
                padding: '0 15px',
                borderRadius: '8px',
                border: '1px solid #C5D0DE',
                fontSize: '16px',
                fontFamily: 'Outfit, sans-serif'
              }}
              placeholder="Enter your full name"
            />
          </div>
          
          <div style={{marginBottom: '20px'}}>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              color: '#131A1A',
              fontSize: '16px',
              fontFamily: 'Outfit, sans-serif',
              fontWeight: '500'
            }}>
              Email <span style={{color: '#F04915'}}>*</span>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                height: '48px',
                padding: '0 15px',
                borderRadius: '8px',
                border: '1px solid #C5D0DE',
                fontSize: '16px',
                fontFamily: 'Outfit, sans-serif'
              }}
              placeholder="Enter your email"
            />
          </div>

          <div style={{marginBottom: '20px'}}>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              color: '#131A1A',
              fontSize: '16px',
              fontFamily: 'Outfit, sans-serif',
              fontWeight: '500'
            }}>
              University ID <span style={{color: '#F04915'}}>*</span>
            </label>
            <input
              type="text"
              name="university_id"
              value={formData.university_id}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                height: '48px',
                padding: '0 15px',
                borderRadius: '8px',
                border: '1px solid #C5D0DE',
                fontSize: '16px',
                fontFamily: 'Outfit, sans-serif'
              }}
              placeholder="Enter your university ID"
            />
          </div>
          
          <div style={{marginBottom: '20px'}}>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              color: '#131A1A',
              fontSize: '16px',
              fontFamily: 'Outfit, sans-serif',
              fontWeight: '500'
            }}>
              Password <span style={{color: '#F04915'}}>*</span>
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              minLength={6}
              style={{
                width: '100%',
                height: '48px',
                padding: '0 15px',
                borderRadius: '8px',
                border: '1px solid #C5D0DE',
                fontSize: '16px',
                fontFamily: 'Outfit, sans-serif'
              }}
              placeholder="Create a password"
            />
          </div>
          
          <div style={{marginBottom: '25px'}}>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              color: '#131A1A',
              fontSize: '16px',
              fontFamily: 'Outfit, sans-serif',
              fontWeight: '500'
            }}>
              Confirm Password <span style={{color: '#F04915'}}>*</span>
            </label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                height: '48px',
                padding: '0 15px',
                borderRadius: '8px',
                border: '1px solid #C5D0DE',
                fontSize: '16px',
                fontFamily: 'Outfit, sans-serif'
              }}
              placeholder="Confirm your password"
            />
          </div>
          
          <button 
            type="submit" 
            disabled={loading}
            style={{
              width: '100%',
              height: '48px',
              background: '#F04915',
              border: 'none',
              borderRadius: '8px',
              color: 'white',
              fontSize: '16px',
              fontFamily: 'Outfit, sans-serif',
              fontWeight: '500',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1
            }}
          >
            {loading ? 'Registering...' : 'Register as Admin'}
          </button>
        </form>
        
        <div style={{
          textAlign: 'center',
          marginTop: '20px',
          color: '#798AA3',
          fontSize: '14px',
          fontFamily: 'Outfit, sans-serif'
        }}>
          Already have an account? <Link to="/login" style={{color: '#F04915', fontWeight: '500', textDecoration: 'none'}}>Sign In</Link>
        </div>
      </div>
    </div>
  );
};

export default Register;